import { Store } from '@ngrx/store';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { UserSelector } from 'src/app/shared/store/user/user.feature';
import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RedirectCommand,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { ROUTES } from 'src/app/app.routes.constants';

export const userLoggedInGuard: CanActivateFn = (
  _route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
) => {
  const store = inject(Store);
  const router = inject(Router);
  const url = state.url;
  const loginPath = router.parseUrl(`${ROUTES.login}?returnUrl=${url}`);
  const redirectToLogin = new RedirectCommand(loginPath);
  const isLoggedIn$ = store.select(UserSelector.selectIsLoggedIn);
  // TODO add returnUrl param
  return isLoggedIn$.pipe(map(isLoggedIn => isLoggedIn || redirectToLogin));
};
